<template>
  <div
    class="py-4 p-st"
    :class="{
      'bg-light': !nightMode,
      'bg-dark2': nightMode,
      'text-light': nightMode,
    }"
  >
    <!-- <div class="container">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
        style="margin-top: 30px"
      >
        <span
          class="mid-text text-center"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >About Me</span
        >
      </div>
 
      <h1 style="font-size: 0.5rem">
        <i class="fas fa-circle fa-lg" style="margin-top: 2px"></i>
      </h1>

      <div class="row">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="education" :nightMode="nightMode" />
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="experience" :nightMode="nightMode" />
        </div>
    </div>
    </div> -->
  </div>
</template>

<script>
import Timeline from "./helpers/Timeline";
import info from "../../info";

export default {
  name: "About",
  components: {
    Timeline,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      // education: {
      //   title: "Education",
      //   data: info.education,
      // },
      // experience: {
      //   title: "Experiences",
      //   data: info.experience,
      // },
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 200px;
}
.row{
  margin-top: 60px;
}
.mid-text {
  /* color: #222222; */
  margin-top: 100px;
  font-weight: 600;
  position: relative;
  margin-bottom: 200px;
  font-size: 40px;
  line-height: 44px;
}
.pg-red {
  background-color: #ff1702;
}
h1:before {
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background: #e45447;
  left: 0;
  top: 50%;
  position: absolute;
}
h1:after {
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background: #e45447;
  right: 0;
  top: 50%;
  position: absolute;
}

h1 {
  font-family: sans-serif;
  margin: 15px auto;
  color: #e45447;
  text-align: center;
  font-size: 30px;
  max-width: 100px;
  position: relative;
}

</style>
